/** @flow */
import customEnv from './customEnv.js'

const { protocol } = window.location

type Env = 'develop' | 'preproduction' | 'production'

type ProcessEnv = {
  NODE_ENV: Env,
  OVM: {
    API_URL: string,
    SOCKET_URL?: string,
    ENV?: Env,
    PORT?: number,
    SENTRY_DSN?: string,
    SENTRY_URL?: string,
    SENTRY_AUTH_TOKEN?: string,
    SENTRY_ORG?: string,
    SENTRY_PROJECT?: string,
    CI_COMMIT_TAG?: string,
    CI_COMMIT_REF_NAME?: string,
  },
}

type Settings = {
  cookieToken: 'ovm_auth',
  git: {
    CI_COMMIT_TAG?: string,
    CI_COMMIT_REF_NAME?: string,
  },
  sentry: {
    SENTRY_DSN?: string,
    SENTRY_URL?: string,
    SENTRY_AUTH_TOKEN?: string,
    SENTRY_ORG?: string,
    SENTRY_PROJECT?: string,
  },
  env: {
    API_URL: string,
    SOCKET_URL: string | null,
    NODE_ENV: ?Env,
    PORT?: number,
  },
}

const testInstancesDomain = 'yuzu-software.com'
const { location } = window

function constructUrl(url?: ?string, subdomain?: string, port?: number, type?: string, env?: string): string {
  console.log('env', env)
  if (subdomain) {
    return `${protocol}//${subdomain}${testInstancesDomain}${port ? `:${port}` : ''}/${type}`
  }
  if (!url) {
    return ''
  }
  return `${protocol}//${url}${port && env !== 'development' ? `:${port}` : ''}/${type}`
}

function constructWSUrl(env?: string, apiUrl?: string, subdomain?: string, port?: number) {
  if (subdomain) {
    return `wss://${subdomain}${testInstancesDomain}${port ? `:${port}` : ''}/api/ws`
  }
  return `${env === 'development' ? 'ws' : 'wss'}://${apiUrl}${port ? `:${port}` : ''}/api/ws/`
}

const processEnv: Object | ProcessEnv = process.env

const { NODE_ENV, OVM } = processEnv

const {
  API_URL,
  SOCKET_URL,
  ENV,
  PORT,
  SENTRY_DSN,
  SENTRY_URL,
  SENTRY_AUTH_TOKEN,
  SENTRY_ORG,
  SENTRY_PROJECT,
  CI_COMMIT_TAG,
  CI_COMMIT_REF_NAME,
} = { ...OVM, ...customEnv }

const env: Env = ENV || NODE_ENV

// if (NODE_ENV !== 'test' && !API_URL) throw new Error('API_URL should be setted up.')

const getURLSubdomain = () => {
  const URLSubdomain = location.host.split('.')[0]

  if (URLSubdomain === 'ovm' || ['development', 'preproduction', 'test'].includes(env)) {
    return ''
  }
  return `${URLSubdomain}.`
}

const subdomain = getURLSubdomain()

const settings: Settings = Object.freeze({
  cookieToken: 'ovm_auth',
  env: {
    API_URL: constructUrl(API_URL, subdomain, location.port || PORT, 'api', env),
    SOCKET_URL: constructUrl(SOCKET_URL, subdomain, '', 'sock'),
    WS_URL: constructWSUrl(env, API_URL, subdomain, location.port || PORT),
    NODE_ENV: env,
  },
  sentry: {
    SENTRY_DSN,
    SENTRY_URL,
    SENTRY_AUTH_TOKEN,
    SENTRY_ORG,
    SENTRY_PROJECT,
  },
  git: {
    CI_COMMIT_TAG,
    CI_COMMIT_REF_NAME,
  },
})

export const isProd = (): boolean => env === 'production'

export default settings
